import { render, staticRenderFns } from "./menu-button.vue?vue&type=template&id=d204dae4&"
import script from "./menu-button.vue?vue&type=script&lang=js&"
export * from "./menu-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports